import Vue from 'vue'
import VueRouter from 'vue-router'
import SurveyForm from '@/views/SurveyForm.vue'
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'SurveyForm',
        component: SurveyForm,
        meta: { title: '上海国际设计周设计选材展・家装节 门票免费申领' }
    },
    // 可选：重定向无效路径到首页
    {
        path: '*',
        redirect: '/'
    }
]

const router = new VueRouter({
    mode: 'history', // 使用 HTML5 History 模式（更干净的 URL）
    base: process.env.BASE_URL,
    routes
})

// 可选：页面切换时自动更新 document.title
router.beforeEach((to, from, next) => {
    document.title = to.meta.title || '作品投票系统'
    next()
})

export default router